@if (selectionInGroup()) {
  <rt-checkbox
    [checked]="selectionInGroup() === 'all'"
    [indeterminateState]="selectionInGroup() === 'indeterminate'"
    (click)="select.emit(group())"
  />
} @else {
  @let groupValue = group();
  @if (groupValue.type === 'admin') {
    <rt-avatar [imageSrc]="groupValue.avatarUrl" type="image" size="small-x" margin-lr-small-xx />
  }
  @if (groupValue.type === 'job_status') {
    <rt-offer-status-indicator
      [offerStatus]="{ kind: 'job', status: groupValue.id }"
      margin-left-small-xx
      margin-right-small-x
    />
  }
}

<rt-board-group-header
  [group]="group()"
  [selectionInGroup]="selectionInGroup()"
  [count]="count()"
/>
